/**
 * Swiper Navigation
 *
 * @module app/components/SwiperNavigation
 */
import jQuery from 'jquery';
import MessageBusTopics from '../../common/MessageBusTopics';

/**
 * Set action on swiper-slide for Goalscorer compoment on Mobile view
 *
 * @param {String} Name of the swiper
 *
 * @returns {void}
 *
 * @private
 */
var setEventsSwiper = function (name) {

    var targetClip = jQuery('#' + name);
    var oddsToDisplay;

    targetClip.find('.filter-list__item')
        .off('click.addActiveClass')
        .on('click.addActiveClass', function () {
            if( jQuery(this).find('a#byo-link').length > 0 ) { return; }

            targetClip.find('.filter-list__link--active')
                .removeClass('filter-list__link--active');
            jQuery(this).find('.filter-list__link')
                .addClass('filter-list__link--active');

            if (targetClip.find('[data-action="add-class-to-tab"]')) {

                oddsToDisplay = jQuery(this).find('a.filter-list__link--active')
                    .attr('data-type-odds');
                jQuery(this).parents('.tabs').find('div[data-type-odds-selected]')
                    .attr('data-type-odds-selected', oddsToDisplay);
            }
        });
};

/**
 * Public functions.
 *
 * @type {Object}
 */
var api = {

    /**
     * Initialize Swiper
     *
     * @param {String} name Name of the swiper
     *
     * @returns {void}
     *
     * @public
     */
    init: function (name) {

        setEventsSwiper(name);
    },

    /**
     * Reinitialize Swiper
     *
     * @param {String} name Name of the swiper
     *
     * @returns {void}
     *
     * @public
     */
    reInit: function (name) {

        setEventsSwiper(name);
    },

    /**
     * Function to initalize all Swipers on page
     *
     * @returns {void}
     *
     * @public
     */
    initializeAllSwipers: function () {

        /**
         * Initialize single swiper
         *
         * @returns {void}
         *
         * @private
         */
        var initializeSingleSwiper = function () {

            var name = jQuery(this).attr('id');

            api.init(name);

            jQuery(this).removeClass('initializeSwiper');
        };

        jQuery('#main').find('.initializeSwiper').each(initializeSingleSwiper);
    },
};

export default api;
